import React from "react";
import ContentContainer from "./contentContainer";
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import Grid from '@mui/material/Grid2';
import PageTitle from "./pageTitle";
import './g3Components.css';
import DownloadLink from "./downloadLink";

export default function G3Components() {
    return (
        <ContentContainer>
            <PageTitle title='Mercury Computer Diagnostic Systems Part Numbers' />

            <Box component="main" sx={{ p: 3, width: '100%' }} className="g3-components">
                <Grid container>
                    <Grid item size={12}>
                        <div className='component-list'>
                            <ul>
                                <li>
                                    <strong>CDS G3 License Key P/N: 8M0242036</strong>
                                    <span>
                                        One must be ordered for each device running CDS G3
                                        <br />
                                        <img title='CDS G3 License Key P/N: 8M0242036' src='g3-license-card-2024.png' />
                                    </span>
                                </li>
                                <li>
                                    <strong>CDS G3 Kit P/N: 8M0168921</strong>
                                    <span>
                                        Includes cables, and SmartCraft interface, does NOT include License
                                        <br />
                                        <img title='CDS G3 License Key P/N: 8M0215503' src='g3-smartcraft-kit.jpg' style={{ maxHeight: '150px' }} />
                                    </span>
                                    <TableContainer>
                                        <Table size="small">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Ref</TableCell>
                                                    <TableCell>Qty</TableCell>
                                                    <TableCell>Description</TableCell>
                                                    <TableCell>Part Number</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell>a</TableCell>
                                                    <TableCell>1</TableCell>
                                                    <TableCell>CDS G3 SmartCraft diagnostic interface</TableCell>
                                                    <TableCell>898289T81</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>b</TableCell>
                                                    <TableCell>1</TableCell>
                                                    <TableCell>CAN P/CAN H adapter harness</TableCell>
                                                    <TableCell>898289T83</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>c</TableCell>
                                                    <TableCell>1</TableCell>
                                                    <TableCell>CDS G3 engine harness adapter (with termination resistor)</TableCell>
                                                    <TableCell>8M0046081</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </li>
                                <li>
                                    <strong>CDS G3 Serial Kit P/N: 8M0137534</strong>
                                    <span>
                                        Includes serial cables, and serial interface, does NOT include License
                                        <br />
                                        <img title='CDS G3 License Key P/N: 8M0215503' src='serial-kit.jpg' />
                                    </span>
                                    <TableContainer>
                                        <Table size="small">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Ref</TableCell>
                                                    <TableCell>Qty</TableCell>
                                                    <TableCell>Description</TableCell>
                                                    <TableCell>Part Number</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell>a</TableCell>
                                                    <TableCell>1</TableCell>
                                                    <TableCell>CDS G3 serial diagnostic interface</TableCell>
                                                    <TableCell>8M0137535</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>b</TableCell>
                                                    <TableCell>1</TableCell>
                                                    <TableCell>CDS G3 serial adapter</TableCell>
                                                    <TableCell>8M0137536</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>c</TableCell>
                                                    <TableCell>1</TableCell>
                                                    <TableCell>8-20hp serial adapter harness</TableCell>
                                                    <TableCell>8M0137537</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>d</TableCell>
                                                    <TableCell>1</TableCell>
                                                    <TableCell>25-30hp serial adapter harness</TableCell>
                                                    <TableCell>899150T01</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </li>
                                <li>
                                    <strong>MDDT Kit P/N: 8M0133211</strong>
                                    <span>
                                        <img title='MDDT P/N: 8M0133211' src='mddt.jpg' />
                                    </span>
                                    <br />
                                    <DownloadLink fileName='MDDT_install_Manual_Rev_B_20180730_3.pdf' label='MDDT Installation Manual' />
                                </li>
                                <li>
                                    <strong>1 kWh battery interface harness P/N: 8M0214517</strong>
                                </li>
                                <li>
                                    <strong>CDS G3 Avator 2300 Wh & 5400 Wh battery interface harness kit P/N: 8M0218478</strong>
                                </li>
                            </ul>
                        </div>
                    </Grid>
                </Grid>
            </Box >

        </ContentContainer>
    )
}